export default "__VITE_ASSET__CzfAqlGO__"